<mat-form-field floatLabel="always" class="w-full min-w-0">
    <mat-label>{{ caption }}</mat-label>
    <mat-select placeholder="{{ caption }}" [formControl]="control" (selectionChange)="valueChanged()">
        @for (time of times(); track time) {
            <mat-option [value]="time">{{ time }}</mat-option>
        }
    </mat-select>
</mat-form-field>